/*
 * NhN Select / Orange Whip: LINE Yahoo click attribution v2.0.0
 * Prepared 2026-11-04. No requests to ad platforms, no payment/order creation.
 * Works only on cloned theme 193591738552, including when it becomes main.
 * Unpublished/development themes use a TEST namespace that the CSV tool rejects.
 * Does not read names, emails, addresses, or change pixels/payment settings.
 * Cart attributes are best-effort; accelerated checkout and CSV pass-through
 * require actual-order verification. Not a full replacement for official pixels.
 */
(() => {
  'use strict';
  const VERSION = '2.0.0';
  const THEME_ID = '193591738552';
  const SHOP = 'xvwpb5-nx';
  const HOSTS = ['orangewhipgolf.jp', 'www.orangewhipgolf.jp', 'xvwpb5-nx.myshopify.com'];
  const s = window.Shopify;
  if (!s || !s.theme || String(s.theme.id) !== THEME_ID ||
      !HOSTS.includes(location.hostname) || s.designMode || window.OWLYAttribution ||
      !['main', 'unpublished', 'development'].includes(s.theme.role)) return;
  const MODE = s.theme.role === 'main' ? 'live' : 'test';
  const KEY = 'ow_ly_v2_' + SHOP + '_' + MODE;
  const ATTR = MODE === 'live' ? '__ow_ly_v2' : '__ow_ly_test_v2';
  const PREFIX = MODE === 'live' ? 'OWLY2.' : 'OWLYTEST2.';
  const OLD_TEST_KEYS = ['ow_ly_test_v1_' + THEME_ID, 'ow_ly_test_v1_' + THEME_ID + '_debug'];
  const OLD_TEST_ATTRS = ['__ow_ly_test_v1', 'ow_ly_test_v1__'];
  const TTL = 30 * 86400000;
  const REQUEST_MS = 6000;
  const NAVIGATION_MS = 1100;
  const state = {version: VERSION, mode: MODE, themeId: THEME_ID, status: 'starting',
    privacy: 'unknown', storage: 'unknown', channel: '', clickIdTail: '', error: ''};
  let record = null;
  let touched = false;
  let legacy = false;
  let acceptedSignature = '';
  let chain = Promise.resolve();
  let activeController = null;
  let expiryTimer = null;
  let refreshTimer = null;
  let generation = 0;
  let blockedIncoming = '';
  let clearedThisPage = false;

  // Conservative validation: UNKNOWN formats are not altered or guessed.
  function idOK(id) {
    return typeof id === 'string' && /^[A-Za-z0-9][A-Za-z0-9._~-]{0,299}$/.test(id) &&
      !/^OWLY_TEST_/i.test(id) && !/^(TEST|DEMO|EXAMPLE)(?:[_-]|$)/i.test(id);
  }
  function privacyReady() {
    const p = window.Shopify && window.Shopify.customerPrivacy;
    return !!p && ['analyticsProcessingAllowed', 'marketingAllowed', 'saleOfDataAllowed']
      .every(k => typeof p[k] === 'function');
  }
  function allowed() {
    try {
      const p = window.Shopify.customerPrivacy;
      return p.analyticsProcessingAllowed() === true && p.marketingAllowed() === true &&
        p.saleOfDataAllowed() === true;
    } catch (_) {return false;}
  }
  function valid(r) {
    const now = Date.now();
    return !!r && r.v === 2 && r.shop === SHOP && r.mode === MODE &&
      r.test === (MODE !== 'live') && idOK(r.yclid) &&
      ['search', 'display', 'unknown'].includes(r.channel) &&
      Number.isSafeInteger(r.capturedMs) && r.capturedMs <= now &&
      Number.isSafeInteger(r.expiresMs) && r.expiresMs === r.capturedMs + TTL &&
      r.expiresMs > now;
  }
  function forget() {
    if (record) touched = true;
    record = null; acceptedSignature = ''; generation++;
    clearTimeout(expiryTimer);
    state.channel = ''; state.clickIdTail = '';
    try {localStorage.removeItem(KEY);} catch (_) {}
  }
  function cleanLegacyStorage() {
    for (const key of OLD_TEST_KEYS) {
      try {if (localStorage.getItem(key)) legacy = true; localStorage.removeItem(key);} catch (_) {}
    }
    if (MODE === 'live') {
      try {
        const key = 'ow_ly_v2_' + SHOP + '_test';
        if (localStorage.getItem(key)) legacy = true;
        localStorage.removeItem(key);
      } catch (_) {}
    }
  }
  function readRecord() {
    if (valid(record)) return;
    try {
      const raw = localStorage.getItem(KEY);
      state.storage = 'available';
      if (raw) {
        touched = true;
        const r = JSON.parse(raw);
        if (valid(r)) {record = r; return;}
        if (r && typeof r.yclid === 'string' && r.expiresMs <= Date.now()) blockedIncoming = r.yclid;
        localStorage.removeItem(KEY);
      }
    } catch (_) {state.storage = 'unavailable';}
    if (record && record.expiresMs <= Date.now()) blockedIncoming = record.yclid;
    record = null;
  }
  function channelFor(id, hint) {
    const isSearch = id.startsWith('YSS') && id.length > 3;
    if (hint && !['search', 'display'].includes(hint)) return 'unknown';
    if (hint === 'search') return isSearch ? 'search' : 'unknown';
    if (hint === 'display') return isSearch ? 'unknown' : 'display';
    return isSearch ? 'search' : 'unknown';
  }
  function capture() {
    readRecord();
    const q = new URL(location.href).searchParams;
    const ids = q.getAll('yclid'), hints = q.getAll('ow_ly_channel');
    // Never promote synthetic test URLs/data into live conversion data.
    if (q.has('ow_ly_test') || ids.length > 1 || hints.length > 1 ||
        (ids.length && !idOK(ids[0]))) {
      forget(); state.status = 'ignored_test_or_invalid_url'; return;
    }
    const id = ids[0];
    if (id && id !== blockedIncoming) {
      const ch = channelFor(id, hints[0] || '');
      if (!record || record.yclid !== id) {
        const now = Date.now();
        record = {v: 2, shop: SHOP, mode: MODE, test: MODE !== 'live',
          yclid: id, channel: ch, capturedMs: now, expiresMs: now + TTL};
        generation++; acceptedSignature = '';
      } else if (hints.length && record.channel !== ch) {
        // Conflicting classification is held for review, not sent to both accounts.
        record.channel = record.channel === 'unknown' ? ch : 'unknown';
        generation++; acceptedSignature = '';
      }
    }
    if (!valid(record)) {record = null; return;}
    record.permission = 'analytics+marketing+sale_allowed';
    record.permissionCheckedMs = Date.now();
    touched = true;
    state.channel = record.channel;
    state.clickIdTail = record.yclid.slice(-8);
    try {localStorage.setItem(KEY, JSON.stringify(record)); state.storage = 'available';}
    catch (_) {state.storage = 'memory_only';}
    clearTimeout(expiryTimer);
    expiryTimer = setTimeout(() => refresh(true), Math.min(record.expiresMs - Date.now() + 1, 2147483647));
  }
  function encoded(r) {
    return PREFIX + btoa(JSON.stringify(r)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
  }
  function attributes() {
    const a = {[ATTR]: allowed() && valid(record) ? encoded(record) : ''};
    for (const name of OLD_TEST_ATTRS) a[name] = '';
    if (MODE === 'live') a.__ow_ly_test_v2 = '';
    return a;
  }
  function cartURL() {
    const base = new URL((window.Shopify.routes && window.Shopify.routes.root) || '/', location.origin);
    if (base.origin !== location.origin) throw new Error('invalid_cart_origin');
    if (!base.pathname.endsWith('/')) base.pathname += '/';
    return new URL('cart/update.js', base).href;
  }
  function isCartForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    try {
      const u = new URL(form.action || '', location.href);
      return u.origin === location.origin && /\/cart\/?$/.test(u.pathname);
    } catch (_) {return false;}
  }
  function injectIntoCartForm(form) {
    if (!isCartForm(form)) return;
    const a = attributes();
    for (const key of Object.keys(a)) {
      const name = 'attributes[' + key + ']';
      let input = Array.from(form.querySelectorAll('input')).find(i => i.name === name);
      if (!input) {
        input = document.createElement('input'); input.type = 'hidden'; input.name = name;
        input.dataset.owLyOwned = '1'; form.appendChild(input);
      }
      input.value = a[key];
    }
  }
  function syncForms() {
    document.querySelectorAll('form').forEach(injectIntoCartForm);
  }
  async function write(force, clearOnly) {
    if (!clearOnly && (!allowed() || !valid(record))) return false;
    const snapshot = clearOnly ? null : {...record};
    const signature = snapshot ? [snapshot.yclid, snapshot.channel, snapshot.capturedMs].join('|') : '';
    if (!force && signature && signature === acceptedSignature) return true;
    if (!snapshot && clearedThisPage && !force) return true;
    const atGeneration = generation;
    const a = attributes();
    if (clearOnly) a[ATTR] = '';
    const controller = new AbortController(); activeController = controller;
    const timeout = setTimeout(() => controller.abort(), REQUEST_MS);
    try {
      state.status = snapshot ? 'saving' : 'clearing';
      const response = await fetch(cartURL(), {method: 'POST', credentials: 'same-origin', cache: 'no-store',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({attributes: a}), signal: controller.signal});
      if (!response.ok) throw new Error('HTTP_' + response.status);
      await response.json();
      if (atGeneration !== generation) return false;
      state.error = '';
      if (snapshot && allowed() && valid(record)) {
        acceptedSignature = signature; clearedThisPage = false; state.status = 'request_accepted';
      } else {acceptedSignature = ''; clearedThisPage = true; state.status = 'cleared';}
      legacy = false;
      return true;
    } catch (e) {
      state.error = e && e.name === 'AbortError' ? 'timeout' : 'cart_request_failed';
      state.status = 'save_failed_purchase_unblocked'; return false;
    } finally {clearTimeout(timeout); if (activeController === controller) activeController = null;}
  }
  function enqueue(force, clearOnly) {
    const run = chain.catch(() => false).then(() => write(force, clearOnly));
    chain = run.catch(() => false); return run;
  }
  async function refresh(force = false, checkoutIntent = false) {
    try {
      if (!privacyReady()) {state.status = 'privacy_unavailable'; state.privacy = 'unknown'; return false;}
      if (!allowed()) {
        state.privacy = 'not_allowed';
        forget(); syncForms();
        if (activeController) activeController.abort();
        if (touched || legacy || checkoutIntent || /\/cart\/?$/.test(location.pathname))
          return enqueue(force, true);
        state.status = 'not_allowed'; return false;
      }
      state.privacy = 'allowed'; capture(); syncForms();
      if (!record) {
        if (touched || legacy || checkoutIntent || /\/cart\/?$/.test(location.pathname))
          return enqueue(force, true);
        if (state.status !== 'ignored_test_or_invalid_url') state.status = 'no_click_id';
        return true;
      }
      return enqueue(force, false);
    } catch (_) {state.status = 'safe_failure'; state.error = 'unexpected_error'; return false;}
  }
  async function beforeNavigation() {
    let timer;
    try {
      return await Promise.race([refresh(true, true), new Promise(resolve => {
        timer = setTimeout(() => resolve(false), NAVIGATION_MS);
      })]);
    } catch (_) {return false;} finally {clearTimeout(timer);}
  }
  function schedule() {
    clearTimeout(refreshTimer); refreshTimer = setTimeout(() => refresh(true), 150);
  }
  function start() {
    try {
      cleanLegacyStorage();
      document.addEventListener('visitorConsentCollected', () => {
        if (!allowed() && activeController) activeController.abort();
        refresh(true);
      });
      document.addEventListener('submit', event => {
        if (!isCartForm(event.target)) return;
        // Use the normal cart POST; no prevention, delay, or replacement of checkout.
        if (privacyReady() && allowed()) capture(); else forget();
        injectIntoCartForm(event.target);
      }, true);
      document.addEventListener('shopify:section:load', schedule);
      window.addEventListener('pageshow', event => {if (event.persisted) refresh(true);});
      window.addEventListener('storage', event => {
        if (event.key === KEY) {record = null; acceptedSignature = ''; refresh(true);}
      });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined')
        subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
      if (privacyReady()) {refresh(); return;}
      let attempts = 0;
      const load = () => {
        if (privacyReady()) {refresh(); return;}
        if (typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
            if (error) state.status = 'privacy_unavailable'; else refresh();
          });
        } else if (++attempts < 20) setTimeout(load, 250);
        else state.status = 'privacy_unavailable';
      };
      load();
    } catch (_) {state.status = 'safe_failure';}
  }
  window.OWLYAttribution = Object.freeze({version: VERSION, beforeNavigation,
    refresh: () => refresh(true), status: () => ({...state})});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();


/* Original theme behavior, with one bounded attribution hook. */
(() => {
  const initialized = new WeakSet();

  function syncModelGuides(variantId) {
    document.querySelectorAll('[data-ow-model-card]').forEach((card) => {
      card.classList.toggle('is-selected', card.dataset.owModelCard === String(variantId));
    });
    document.querySelectorAll('[data-ow-select-variant]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.owSelectVariant === String(variantId)));
    });
  }

  function initProductSection(section) {
    if (!section || initialized.has(section)) return;
    initialized.add(section);
    const controller = new AbortController();
    const listenerOptions = { signal: controller.signal };
    let overlayObserver = null;
    let stickyResizeObserver = null;
    let lastStickyHeight = 0;

    const form = section.querySelector('[data-ow-product-form]');
    const hiddenId = section.querySelector('[data-ow-variant-id]');
    const price = section.querySelector('[data-ow-price]');
    const stock = section.querySelector('[data-ow-stock]');
    const addButton = section.querySelector('[data-ow-add]');
    const cartButtons = Array.from(section.querySelectorAll('[data-ow-add-to-cart]'));
    const checkoutButtons = Array.from(section.querySelectorAll('[data-ow-checkout]'));
    const quantity = section.querySelector('[data-ow-quantity]');
    const image = section.querySelector('.ow-product__image');
    const productUrl = section.dataset.owProductUrl;
    const productLabel = section.dataset.owProductLabel || '';
    const stickyBuy = section.querySelector('[data-ow-sticky-buy]');
    const topPurchase = section.querySelector('[data-ow-top-purchase]');
    const stickyModel = section.querySelector('[data-ow-sticky-model]');
    const stickyPrice = section.querySelector('[data-ow-sticky-price]');
    const stickyStock = section.querySelector('[data-ow-sticky-stock]');
    const stickyQuantity = section.querySelector('[data-ow-sticky-quantity]');
    const stickyVariant = section.querySelector('[data-ow-sticky-variant]');
    const stickyContent = section.querySelector('[data-ow-sticky-content]');
    const stickyCollapse = section.querySelector('[data-ow-sticky-collapse]');
    const stickyExpand = section.querySelector('[data-ow-sticky-expand]');
    const checkoutError = section.querySelector('[data-ow-checkout-error]');
    const checkoutErrorMessage = section.querySelector('[data-ow-checkout-error-message]');
    let stickyCollapsed = true;
    let stickyFrame = 0;
    let purchaseSubmitting = false;

    function setPurchaseState(available, submitting = false) {
      cartButtons.forEach((button) => {
        button.disabled = !available || submitting;
        if (submitting) button.setAttribute('aria-busy', 'true');
        else button.removeAttribute('aria-busy');
        const label = button.querySelector('[data-ow-cart-label]');
        if (label) label.textContent = available ? 'カートに追加する' : '売り切れ';
      });
      checkoutButtons.forEach((button) => {
        button.disabled = !available || submitting;
        if (submitting) button.setAttribute('aria-busy', 'true');
        else button.removeAttribute('aria-busy');
        const label = button.querySelector('[data-ow-checkout-label]');
        if (label) label.textContent = available ? '購入手続きへ' : '売り切れ';
      });
    }

    function currentPurchaseAvailable() {
      const selected = section.querySelector('[data-ow-variant-radio]:checked');
      if (selected) return selected.dataset.available === 'true';
      return Boolean(hiddenId?.value && !hiddenId.disabled);
    }

    function setStickyContentInert(inert) {
      if (!stickyContent) return;
      if (inert) stickyContent.setAttribute('inert', '');
      else stickyContent.removeAttribute('inert');
    }

    function applyStickyPresentation(moveFocus = false) {
      if (!stickyBuy || !stickyContent || !stickyCollapse || !stickyExpand) return;
      const fixed = stickyBuy.classList.contains('is-fixed');

      if (!fixed) {
        stickyBuy.classList.remove('is-collapsed');
        stickyContent.hidden = false;
        setStickyContentInert(false);
        if (document.activeElement === stickyCollapse || document.activeElement === stickyExpand) {
          const staticFocusTarget = !addButton?.disabled ? addButton : quantity;
          staticFocusTarget?.focus({ preventScroll: true });
        }
        stickyCollapse.hidden = true;
        stickyExpand.hidden = true;
        return;
      }

      stickyCollapse.setAttribute('aria-expanded', String(!stickyCollapsed));
      stickyExpand.setAttribute('aria-expanded', String(!stickyCollapsed));
      if (stickyCollapsed) {
        stickyBuy.classList.add('is-collapsed');
        stickyExpand.hidden = false;
        if (moveFocus && stickyContent.contains(document.activeElement)) {
          stickyExpand.focus({ preventScroll: true });
        }
        stickyCollapse.hidden = true;
        stickyContent.hidden = true;
        setStickyContentInert(true);
      } else {
        stickyBuy.classList.remove('is-collapsed');
        stickyContent.hidden = false;
        setStickyContentInert(false);
        stickyCollapse.hidden = false;
        if (moveFocus && document.activeElement === stickyExpand) {
          stickyCollapse.focus({ preventScroll: true });
        }
        stickyExpand.hidden = true;
      }
    }

    function setStickyCollapsed(collapsed) {
      stickyCollapsed = collapsed;
      applyStickyPresentation(true);
      scheduleStickyUpdate();
    }

    function blockingOverlayIsOpen() {
      const selectors = [
        'dialog[open]',
        'menu-drawer details[open]',
        'details.menu-drawer-container[open]',
        'details-modal details[open]',
        'cart-drawer.active',
        '#shopify-pc__banner:not([hidden])',
        '.shopify-pc__banner__dialog:not([hidden])',
        '[data-shopify-privacy-banner]:not([hidden])',
        'iframe[title*="privacy" i]',
        'iframe[title*="cookie" i]',
      ];
      return selectors.some((selector) => {
        const element = document.querySelector(selector);
        if (!element) return false;
        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0 && rect.width > 0 && rect.height > 0;
      });
    }

    function updateStickyVisibility() {
      if (!stickyBuy || !topPurchase) return;
      const topPurchaseHasScrolledAbove = topPurchase.getBoundingClientRect().bottom <= 0;
      const show = topPurchaseHasScrolledAbove && !blockingOverlayIsOpen();

      if (show) {
        stickyBuy.classList.add('is-fixed');
        stickyBuy.setAttribute('aria-label', '固定購入バー');
        applyStickyPresentation();
        document.body.classList.add('ow-sticky-buy-visible');
        const stickyHeight = Math.ceil(stickyBuy.getBoundingClientRect().height);
        if (stickyHeight !== lastStickyHeight) {
          lastStickyHeight = stickyHeight;
          document.documentElement.style.setProperty('--ow-sticky-buy-height', `${stickyHeight}px`);
        }
      } else {
        stickyBuy.classList.remove('is-fixed');
        stickyBuy.setAttribute('aria-label', '購入操作');
        applyStickyPresentation();
        document.body.classList.remove('ow-sticky-buy-visible');
        document.documentElement.style.removeProperty('--ow-sticky-buy-height');
        lastStickyHeight = 0;
      }
    }

    function scheduleStickyUpdate() {
      if (stickyFrame) return;
      stickyFrame = window.requestAnimationFrame(() => {
        stickyFrame = 0;
        updateStickyVisibility();
      });
    }

    function normalizeQuantity(rawValue, minimum, maximum, increment) {
      const safeMinimum = Number.isFinite(minimum) ? minimum : 1;
      const safeIncrement = Number.isFinite(increment) && increment > 0 ? increment : 1;
      let next = Number.isFinite(rawValue) ? rawValue : safeMinimum;
      next = Math.max(safeMinimum, next);
      next = safeMinimum + Math.floor((next - safeMinimum) / safeIncrement) * safeIncrement;
      if (Number.isFinite(maximum)) {
        const maxOnStep = safeMinimum + Math.max(0, Math.floor((maximum - safeMinimum) / safeIncrement)) * safeIncrement;
        next = Math.min(next, maxOnStep);
      }
      return next;
    }

    function syncVariant(radio, updateUrl) {
      if (!radio || !radio.checked) return;
      const available = radio.dataset.available === 'true';
      hiddenId.value = radio.value;
      hiddenId.disabled = !available;
      hiddenId.dispatchEvent(new Event('change', { bubbles: true }));
      if (price) price.textContent = radio.dataset.price;
      stock.textContent = available ? '在庫あり' : '売り切れ';
      setPurchaseState(available, purchaseSubmitting);
      if (quantity) {
        const minimum = Number.parseInt(radio.dataset.quantityMin || '1', 10);
        const increment = Number.parseInt(radio.dataset.quantityIncrement || '1', 10);
        const maximum = Number.parseInt(radio.dataset.quantityMax || '', 10);
        quantity.min = String(minimum);
        quantity.step = String(increment);
        if (Number.isFinite(maximum)) quantity.max = String(maximum);
        else quantity.removeAttribute('max');
        quantity.value = String(normalizeQuantity(Number.parseInt(quantity.value || '', 10), minimum, maximum, increment));
      }
      if (image && radio.dataset.imageSrc) {
        image.src = radio.dataset.imageSrc;
        image.removeAttribute('srcset');
        image.alt = radio.dataset.imageAlt || image.alt;
      }
      if (stickyModel) {
        const variantLabel = radio.dataset.displayName || radio.dataset.title || radio.value;
        stickyModel.textContent = productLabel ? productLabel + '【' + variantLabel + '】' : variantLabel;
      }
      if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
      if (stickyStock) stickyStock.textContent = available ? '在庫あり' : '売り切れ';
      if (stickyQuantity && quantity) stickyQuantity.textContent = quantity.value;
      if (stickyVariant) stickyVariant.value = radio.value;
      syncModelGuides(radio.value);
      if (updateUrl && productUrl && window.history?.replaceState) {
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', nextUrl);
      }
      scheduleStickyUpdate();
    }

    section.querySelectorAll('[data-ow-variant-radio]').forEach((radio) => {
      radio.addEventListener('change', () => syncVariant(radio, true));
    });
    syncVariant(section.querySelector('[data-ow-variant-radio]:checked'), false);

    stickyVariant?.addEventListener('change', () => {
      const radio = Array.from(section.querySelectorAll('[data-ow-variant-radio]')).find(
        (candidate) => candidate.value === stickyVariant.value,
      );
      if (!radio) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }, listenerOptions);

    stickyCollapse?.addEventListener('click', () => setStickyCollapsed(true), listenerOptions);
    stickyExpand?.addEventListener('click', () => setStickyCollapsed(false), listenerOptions);

    if (form) {
      form.addEventListener('submit', async (event) => {
        const cartSubmitter = event.submitter?.matches?.('[data-ow-add-to-cart]');
        const checkoutSubmitter = event.submitter?.matches?.('[data-ow-checkout]');
        if (!cartSubmitter && !checkoutSubmitter) return;
        event.preventDefault();
        if (purchaseSubmitting) {
          return;
        }
        purchaseSubmitting = true;
        const available = currentPurchaseAvailable();
        setPurchaseState(available, true);
        if (checkoutError) {
          checkoutError.hidden = true;
          if (checkoutErrorMessage) checkoutErrorMessage.textContent = '';
        }

        const selectedId = String(hiddenId?.value || '');
        const selectedQuantity = Number.parseInt(quantity?.value || '1', 10);
        const formData = new FormData(form);
        const requestController = new AbortController();
        const requestTimeout = window.setTimeout(() => requestController.abort(), 15000);

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
            signal: requestController.signal,
          });
          if (!response.ok) throw new Error(`Cart add failed (${response.status})`);
          const result = await response.json();
          const returnedItems = Array.isArray(result?.items) ? result.items : [result];
          const returnedItem = returnedItems.find((item) => String(item?.variant_id || item?.id || '') === selectedId);
          if (!returnedItem || Number(returnedItem.quantity) < selectedQuantity) {
            throw new Error('Cart add response did not match the submitted variant and quantity.');
          }
          // OW-LY: bounded, fail-open save; never changes payment/stock settings.
          try {
            if (window.OWLYAttribution) await window.OWLYAttribution.beforeNavigation();
          } catch (_) { /* Attribution must never prevent a purchase. */ }
          window.location.assign(`${root}${checkoutSubmitter ? 'checkout' : 'cart'}`);
        } catch (error) {
          purchaseSubmitting = false;
          setPurchaseState(currentPurchaseAvailable());
          if (checkoutError) {
            if (checkoutErrorMessage) checkoutErrorMessage.textContent = '処理状況を確認できませんでした。再度押さず、';
            checkoutError.hidden = false;
            checkoutError.focus?.({ preventScroll: true });
          }
          console.error('[Orange Whip] Checkout navigation failed.', error);
        } finally {
          window.clearTimeout(requestTimeout);
        }
      });
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted) return;
        purchaseSubmitting = false;
        setPurchaseState(currentPurchaseAvailable());
        if (checkoutError) checkoutError.hidden = true;
      }, listenerOptions);
    }

    if (quantity) {
      quantity.addEventListener('input', () => {
        if (stickyQuantity) stickyQuantity.textContent = quantity.value;
      }, listenerOptions);
      const changeQuantity = (direction) => {
        const minimum = Number.parseInt(quantity.min || '1', 10);
        const maximum = Number.parseInt(quantity.max || '', 10);
        const increment = Number.parseInt(quantity.step || '1', 10);
        const current = normalizeQuantity(Number.parseInt(quantity.value || '', 10), minimum, maximum, increment);
        const next = normalizeQuantity(current + direction * increment, minimum, maximum, increment);
        quantity.value = String(next);
        quantity.dispatchEvent(new Event('input', { bubbles: true }));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      };
      section.querySelector('[data-ow-quantity-decrease]')?.addEventListener('click', () => changeQuantity(-1));
      section.querySelector('[data-ow-quantity-increase]')?.addEventListener('click', () => changeQuantity(1));
    }

    const gallery = section.querySelector('[data-ow-gallery]');
    if (gallery) {
      const slides = Array.from(gallery.querySelectorAll('[data-ow-gallery-slide]'));
      const thumbnails = Array.from(gallery.querySelectorAll('[data-ow-gallery-thumbnail]'));
      let activeIndex = Math.max(0, slides.findIndex((slide) => !slide.hidden));
      const showSlide = (requestedIndex) => {
        if (!slides.length) return;
        activeIndex = (requestedIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const active = index === activeIndex;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        thumbnails.forEach((thumbnail, index) => {
          const active = index === activeIndex;
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-current', String(active));
        });
      };
      thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => showSlide(index)));
      gallery.querySelector('[data-ow-gallery-previous]')?.addEventListener('click', () => showSlide(activeIndex - 1));
      gallery.querySelector('[data-ow-gallery-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
      showSlide(activeIndex);
    }

    const dialog = section.querySelector('[data-ow-dialog]');
    const dialogImage = section.querySelector('[data-ow-dialog-image]');
    const closeButton = section.querySelector('[data-ow-dialog-close]');
    if (dialog && dialogImage && closeButton && typeof dialog.showModal === 'function') {
      let activeTrigger = null;
      section.querySelectorAll('[data-ow-zoom]').forEach((trigger) => trigger.addEventListener('click', () => {
        const currentImage = trigger.querySelector('img');
        if (!currentImage) return;
        activeTrigger = trigger;
        dialogImage.src = currentImage.currentSrc || currentImage.src;
        dialogImage.alt = currentImage.alt;
        dialog.showModal();
        closeButton.focus();
        scheduleStickyUpdate();
      }));
      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        dialogImage.removeAttribute('src');
        activeTrigger?.focus();
        scheduleStickyUpdate();
      });
    }

    if (stickyBuy && topPurchase) {
      window.addEventListener('scroll', scheduleStickyUpdate, { passive: true, signal: controller.signal });
      window.addEventListener('resize', scheduleStickyUpdate, { passive: true, signal: controller.signal });
      document.addEventListener('click', scheduleStickyUpdate, { capture: true, signal: controller.signal });
      document.addEventListener('keyup', scheduleStickyUpdate, listenerOptions);
      document.addEventListener('toggle', scheduleStickyUpdate, { capture: true, signal: controller.signal });
      if ('MutationObserver' in window) {
        overlayObserver = new MutationObserver(scheduleStickyUpdate);
        overlayObserver.observe(document.body, {
          subtree: true,
          childList: true,
        });
      }
      if ('ResizeObserver' in window) {
        stickyResizeObserver = new ResizeObserver(() => {
          if (stickyBuy.classList.contains('is-fixed')) scheduleStickyUpdate();
        });
        stickyResizeObserver.observe(stickyBuy);
      }
      updateStickyVisibility();
    }

    section.owCleanup = () => {
      controller.abort();
      overlayObserver?.disconnect();
      stickyResizeObserver?.disconnect();
      if (stickyFrame) window.cancelAnimationFrame(stickyFrame);
      if (stickyBuy?.classList.contains('is-fixed')) {
        document.body.classList.remove('ow-sticky-buy-visible');
        document.documentElement.style.removeProperty('--ow-sticky-buy-height');
        lastStickyHeight = 0;
      }
    };
  }

  function initModelGuide(guide) {
    if (!guide || initialized.has(guide)) return;
    initialized.add(guide);
    guide.querySelectorAll('[data-ow-select-variant]').forEach((button) => {
      button.addEventListener('click', () => {
        const radio = Array.from(document.querySelectorAll('[data-ow-variant-radio]')).find(
          (candidate) => candidate.value === button.dataset.owSelectVariant,
        );
        if (!radio || radio.disabled) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        radio.focus({ preventScroll: true });
        document.querySelector('[data-ow-product-form]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  function init(root = document) {
    if (root.matches?.('[data-ow-product-section]')) initProductSection(root);
    if (root.matches?.('[data-ow-model-guide]')) initModelGuide(root);
    root.querySelectorAll('[data-ow-product-section]').forEach(initProductSection);
    root.querySelectorAll('[data-ow-model-guide]').forEach(initModelGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const productSection = event.target.matches?.('[data-ow-product-section]')
      ? event.target
      : event.target.querySelector?.('[data-ow-product-section]');
    productSection?.owCleanup?.();
  });
})();

